import React from 'react';
import Card from "@material-ui/core/Card"
import {CardHeader, CardText} from '@material-ui/core/Card';





export default class About extends React.Component {

    render(){

        return (
          <Card shadow={0} style={{ margin: 'auto', textAlign: 'center' }}>
             <CardHeader
               title="Test and Monitoring applications"
               subtitle="FAQs"
               actAsExpander={true}
             />
             <CardText  >
               Development area
             </CardText>
          </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Component/About.js